<template>
  <b-modal
    v-model="showAddCardDetails"
    data-cy="add-stored-card-modal"
    no-close-on-esc
    hide-footer
    hide-header-close
    static
  >
    <template v-slot:modal-title>
      Add new stored credit card
    </template>

    <loading-spinner
      v-if="loadingSquare"
      data-cy="square-loading-spinner"
      class="square-loading"
    >
      <template v-slot:title>
        Initializing Square payments
      </template>
      Loading secure credit card storage form. Please wait...
    </loading-spinner>

    <loading-spinner
      v-if="processing"
      data-cy="card-storing-spinner"
      class="add-card-processing"
    >
      <template v-slot:title>
        Saving credit card details.
      </template>
      Please wait while the credit card details are stored.
    </loading-spinner>

    <div v-show="!processing">
      <square-payments-store-card
        :account="account"
        :success-component="disableResponseModals ? false : null"
        :failure-component="disableResponseModals ? false : null"
        :error-component="disableResponseModals ? false : null"
        @completed="completeModalClose"
        @error="processError"
        @processing="addCardProcessing"
        @loading="(val) => loadingSquare = val"
      />
      <div class="cancel-button">
        <b-button
          v-show="!loadingSquare"
          data-cy="cancel-store-card-button"
          :disabled="processing"
          @click="(val) => $emit('cancel')"
        >
          cancel
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import SquarePaymentsMixin from '../mixins/square-payments'

export default {
  name: 'square-payments-add-stored-card-modal',
  mixins: [
    SquarePaymentsMixin
  ],
  props: {
    account: {
      type: Object,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    },
    disableResponseModals: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      showAddCardDetails: true,
      processingComplete: true,
      retryableError: false,
      loadingSquare: true
    }
  },
  mounted: function() {
    this.$store.commit('square/PROCESSING_RESULT')
  },
  methods: {
    addCardProcessing: function(val) {
      this.processing = val
    },
    completeModalClose: function(modalResult) {
      if (this.retryableError) {
        this.retryableError = false
        this.$store.commit('square/PROCESSING_RESULT')
        this.$emit('error', null)
      }
      else {
        // Get the processing result
        const result = this.$store.getters['square/processingResult']

        // Close the modal first
        this.showAddCardDetails = false

        // Then emit the appropriate event in the next tick
        this.$nextTick(() => {
          if (result && result.status && result.type === 'card') {
            // Successful card storage
            this.$emit('success', result)
          }
          else {
            // Failed or error result
            this.$emit('error', result)
          }
        })
      }
    },
    processStorecardResponse: function(cardDetails) {
      this.processing = false
      this.processingComplete = true
    },
    processError: function(_err) {
      this.processing = false
      this.processingComplete = true
      this.retryableError = true
      // this.$emit('error', err)
    },
    processStorecard: function(val) {
      this.addCardProcessing = val
    }
  }
}
</script>

<style lang="scss" scoped>
  .cancel-button {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 1.8rem;
  }

</style>
